<template>
  <div id="fantasy-bg" :class="{ 'mindmap-page': isMindMapPage }">
    <div id="msg-area"></div>
    <!-- <Navbar class="nav-sticky" v-if="!isMindMapPage" /> -->
    <router-view></router-view>
    <p class="version">{{ store.version }}</p>
  </div>
</template>

<script>
import Message from "./components/Message.vue";
// import Navbar from "./components/Navbar.vue";
import { createApp, provide,computed } from "vue";
import { useMainStore } from "./stores/mainStore";
import { useRoute } from 'vue-router';

export default {
  name: "App",
  components: {
    // Navbar,
  },
  setup() {

    const isMindMapPage = computed(() => {
      const mindMapRoutes = [
        'MindMap', 
        'MindMapHome', 
        'MindCollect', 
        'HTwbMind', 
        'HTpvpGamePlay', 
        'HTpvpGameSetting', 
        'HTMoleGamePlay', 
        'HTMoleGameSetting', 
        'HTpvpTFGamePlay', 
        'HTpvpTFGameSetting', 
        'HTwbActKitHome',
        'MindCollectNormal',
        'HTwbCardHome',
        'HTwbCardCollect',
        'HTPickGamePlay',
        'HTPickGameSetting',
        'HTPunchBoardPlay',
        'HTPunchBoardSetting',
        'AIPromptHome',
        'AdminLogin',
        'AdminUpload',
        'AIPromptCollect'
      ];
      return mindMapRoutes.includes(route.name);
    });

    const route = useRoute();
    const store = useMainStore();
    //常用:mount彈出信息組件
    const mountMsg = (text) => {
      if (store.mountedMsg) {
        store.mountedMsg.unmount(); //之前mounted卸除
      }
      const child = createApp(Message, { text: text });
      store.setMountedMsg(child);

      child.mount("#msg-area");
    };
    provide("mountMsg", mountMsg);
    return { store, isMindMapPage };
  },
};
</script>

<style lang="less">
@import "./assets/tailwind.css";
.mindmap-page {
  @apply bg-white !important;
  
  // AIPrompt 頁面特殊處理，去除預設間距
  &:has(.ai-prompt-home) {
    height: 100vh;
    overflow: hidden;
    margin: 0;
    padding: 0;
    
  
  }
}
#fantasy-bg {
  @apply min-h-screen bg-cyan-100 relative;
  
  // AIPrompt 頁面精確高度控制
  &.mindmap-page:has(.ai-prompt-home) {
    height: 100vh;
    min-height: unset;
  }
  

  .url-link {
    @apply text-sky-500 underline;
  }

  .nav-sticky {
    position: sticky !important;
    top: 0px;
    z-index: 999;
  }

  .search-bar {
    @apply mt-5;
  }

  .card-wrap {
    @apply pb-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-8;
  }
}

#msg-area {
  position: relative;
}

.version {
  @apply text-blue-400 text-sm absolute right-1 bottom-0;
}

//scrollbar style

/* width */
::-webkit-scrollbar {
  width: 8px;
  background: transparent;
}

/* Track */
::-webkit-scrollbar-track {
  background: transparent;
  /* 將軌道背景設為透明 */
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.1);
  /* 使用淡化的顏色 */
  border-radius: 5px;
  border: 1px solid white;
  /* 添加邊框，創建間隙 */
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.2);
  /* 使用稍深的顏色 */
}
</style>
